import { CheckoutItem } from '../../models/checkout/checkout-item.interface';

export const mockCheckoutItem: CheckoutItem = {
  item: {
    itemTypeCode: 'Dishwasher',
    manufacturerBrandCode: 'Whirlpool',
    serialNumber: 'KA1404511',
    modelNumber: 'KBSN602EPA',
    operationalStatusCode: 'W',
    purchase: {
      price: 123,
      currencyCode: 'USD',
      date: '2025-01-01',
      retailer: 'Whirlpool',
    },
    address: [
      {
        addressCategoryCode: 'BIL',
        addressLine1: '180 Garth Rd Apt TE',
        addressLine2: 'Address line 2',
        addressLine3: 'Scarsdale',
        postalCode: '10583-3839',
        region: 'NY',
        countryCode: 'USA',
        addressOverride: false,
      },
    ],
  },
  itemIterationId: 0,
};
